module.exports = __webpack_public_path__ + "img/Windows.4b3125c.png";